import { render, staticRenderFns } from "./HowToBuyAndroid.vue?vue&type=template&id=79918d39&scoped=true&"
import script from "./HowToBuyAndroid.vue?vue&type=script&lang=js&"
export * from "./HowToBuyAndroid.vue?vue&type=script&lang=js&"
import style0 from "./HowToBuyAndroid.vue?vue&type=style&index=0&id=79918d39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79918d39",
  null
  
)

export default component.exports